import React from 'react'
// import { Link } from "gatsby";
import { render } from "storyblok-rich-text-react-renderer"
import { sbEditable } from "@storyblok/storyblok-editable";


const SectionPublicBenefitsTop = ({ blok }) => {
    // console.log(blok)
    return (
        <div {...sbEditable(blok)}>
            <div className="section" style={{ backgroundColor: "#315748" }}>
                <div className="section"></div>
                <div className="container">
                    <div className="columns is-vcentered">
                        <div className="column is-two-thirds has-text-white">
                            <div className="content is-size-5">
                                <h1
                                    className="is-size-2 label has-text-white"
                                    style={{ marginBottom: "5px !important" }}
                                >{blok.title}</h1>
                                <hr
                                    style={{
                                        backgroundColor: "#FFF",
                                        margin: "0 0 1rem 0"
                                    }}
                                />
                                {render(blok.description)}
                            </div>
                        </div>
                        <div className="column is-one-third has-text-centered-mobile">
                            <img
                                className="service-image"
                                src={blok.image.filename}
                                alt={blok.image.alt}
                            />
                        </div>
                    </div>
                    <div className="notification" style={{ backgroundColor: "#FBD875" }}>
                        <div className="content is-size-5">
                            {render(blok.assistance)}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default SectionPublicBenefitsTop;